import { trpc } from '../lib/trpc.js';
import { formatGbp, formatDateTime } from '../lib/format.js';
import { clsx } from 'clsx';
import { CapacityBar } from '../components/ui/CapacityBar.js';

const STATUS_COLORS: Record<string, string> = {
  PENDING: 'bg-yellow-100 text-yellow-800',
  CONFIRMED: 'bg-blue-100 text-blue-800',
  IN_PROGRESS: 'bg-purple-100 text-purple-800',
  COMPLETED: 'bg-green-100 text-green-800',
  CANCELLED: 'bg-gray-100 text-gray-600',
  NO_SHOW: 'bg-red-100 text-red-800',
};

export function BookingsPage() {
  const { data: thisWeek } = trpc.bookings.thisWeek.useQuery();
  const { data: list, isLoading } = trpc.bookings.list.useQuery({ limit: 50 });

  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl text-navy">Bookings</h1>

      {thisWeek && (
        <div className="card">
          <h2 className="font-display text-xl text-navy mb-4">This Week</h2>
          <div className="grid grid-cols-3 gap-4 mb-4">
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wider">Jobs booked</p>
              <p className="font-mono text-2xl font-medium text-navy">{thisWeek.count}</p>
            </div>
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wider">Revenue</p>
              <p className="font-mono text-2xl font-medium text-navy">{formatGbp(thisWeek.revenue)}</p>
            </div>
            <div />
          </div>
          <CapacityBar bookings={thisWeek.count} />
        </div>
      )}

      {isLoading ? (
        <div className="animate-pulse text-gray-400">Loading bookings…</div>
      ) : (
        <div className="card overflow-hidden">
          <div className="overflow-x-auto -mx-5">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-100">
                  <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                  <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Scheduled</th>
                  <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Value</th>
                  <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Technician</th>
                </tr>
              </thead>
              <tbody>
                {list?.bookings.map((b) => (
                  <tr key={b.id} className="border-b border-gray-50 hover:bg-cream-tint transition-colors">
                    <td className="py-2.5 px-3 font-medium">
                      {b.lead ? [b.lead.firstName, b.lead.lastName].filter(Boolean).join(' ') : '—'}
                    </td>
                    <td className="py-2.5 px-3 text-xs text-gray-500">
                      {b.scheduledAt ? formatDateTime(b.scheduledAt) : '—'}
                    </td>
                    <td className="py-2.5 px-3 font-mono">{formatGbp(Number(b.jobValue))}</td>
                    <td className="py-2.5 px-3">
                      <span className={clsx('text-xs px-2 py-0.5 rounded font-medium', STATUS_COLORS[b.status] ?? 'bg-gray-100')}>
                        {b.status}
                      </span>
                    </td>
                    <td className="py-2.5 px-3 text-xs text-gray-500">{b.technicianName ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
